import moment from "moment";
import React from "react";
import { DATE_FORMAT, BEGIN_TIME } from "./constants";

export const getDateTimeStr = (momentVal: moment.Moment): React.ReactNode => {
    return momentVal.hour(BEGIN_TIME.HOUR).minutes(BEGIN_TIME.MINUTE).seconds(BEGIN_TIME.SECOND).format(DATE_FORMAT);
};
